export default {
  state: undefined,
  graph: { client: undefined },
  me: { id: undefined },
  presences: {}
};
